import { camelCase } from 'change-case';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

/**
 * 日時フォーマット
 * @param datetime
 * @param template
 * templateに応じてフォーマット方法を切り替える
 */
export const datetimeFormat = (
  datetime: dayjs.ConfigType,
  template?: 'datetime' | 'datetime-2' | 'date' | string
): string => {
  switch (template) {
    case undefined:
    case 'datetime':
      return tbsDatetimeFormat(datetime);
    case 'datetime-2':
      return tbsDatetimeFormat2(datetime);
    case 'date':
      return dayjs(datetime).format('YYYY年M月D日');
    default:
      return dayjs(datetime).format(template);
  }
};

// TBS時間に変換する1
const tbsDatetimeFormat = (datetime: dayjs.ConfigType): string => {
  const d = dayjs(datetime);
  const hour = d.hour() % 12;
  if (d.hour() < 4) {
    return d.subtract(1, 'day').format('M/D(dd)深夜H:mm');
  } else {
    return d.format(`M/D(dd)A${hour}:mm`);
  }
};

// TBS時間に変換する2
const tbsDatetimeFormat2 = (datetime: dayjs.ConfigType): string => {
  const d = dayjs(datetime);
  if (d.hour() < 4) {
    return d.subtract(1, 'day').format('M月D日(dd)深夜H時');
  } else {
    return d.format('M月D日(dd)Ah時');
  }
};

const _isObject = (target: any): boolean =>
  Object.prototype.toString.call(target).slice(8, -1).toLowerCase() === 'object';

export const convertSnakeToCamel = (target: any): any => {
  if (Array.isArray(target)) {
    target.forEach((t) => convertSnakeToCamel(t));
  }
  if (_isObject(target)) {
    Object.keys(target).forEach((key) => {
      if (_isObject(target[key]) || Array.isArray(target[key])) {
        convertSnakeToCamel(target[key]);
      }
      // スネークケースをキャメルケースに変換する
      if (key.includes('_')) {
        target[camelCase(key)] = target[key];
        delete target[key];
      }
    });
  }
  return target;
};

/**
 * - ルール：
 *   - 深夜4時を越える場合は翌日になるので「翌午前」表記に
 *   - 深夜4時までの番組の場合「深夜4:00」となる。
 *   - 日跨ぎ線を越えてからスタートする、午前4:00からの番組の場合は「午前4:00」となる
 *
 * @example
 * ①夜中の3時～夜中の4時までの番組の場合
 * 表記：深夜3:00～深夜4:00
 * ②夜中の3時～夜中の5時までの番組の場合
 * 表記：深夜3:00～翌午前5:00
 * ③夜中の4時～朝8時までの番組の場合
 * 表記：午前4:00～午前8:00
 */
export const tbsDatetimeStartEndFormat = (startDatetime: dayjs.ConfigType, endDatetime: dayjs.ConfigType): string => {
  const start = datetimeFormat(startDatetime, 'datetime').split(')')[1];

  // 4時を跨いでいたらEND時間を翌〜にする
  const end =
    dayjs(endDatetime).hour() === 4 && dayjs(endDatetime).minute() == 0
      ? dayjs(endDatetime).subtract(1, 'day').format('深夜H:mm')
      : dayjs(startDatetime).hour() < 4 && dayjs(endDatetime).hour() >= 4
      ? dayjs(endDatetime).format('翌Ah:mm')
      : datetimeFormat(endDatetime, 'datetime').split(')')[1];

  return `${start}〜${end}`;
};
